import Vue from "vue";
import Vuex from "vuex";

import app from "../main";
import menu from "./modules/menu";
import user from "./modules/user";
import chat from "./modules/chat";
import todo from "./modules/todo";
import survey from "./modules/survey";
import restaurant from "./modules/restaurant";
import menus from "./modules/menus";
import room from "./modules/room";
import pos from "./modules/pos";
import tag from "./modules/tag";
import statistique from "./modules/statistique";
import reservation from "./modules/reservation";
import helper from "./modules/helper";
import pack from "./modules/pack";
import manager from "./modules/manager";
import langue from "./modules/langue";
import article from "./modules/article";
import currency from "./modules/currency";
import commande from "./modules/commande";
import order from "./modules/order";
import client from "./modules/client";
import espace from "./modules/espace";

import programmeF from "./modules/ProgrammeF";

import VueHtml2pdf from 'vue-html2pdf'



Vue.use(Vuex);
Vue.use(VueHtml2pdf);


export default new Vuex.Store({
  state: {},
  mutations: {
    changeLang(state, payload) {
      app.$i18n.locale = payload;
      localStorage.setItem("currentLanguage", payload);
    }
  },
  actions: {
    setLang({ commit }, payload) {
      commit("changeLang", payload);
    }
  },
  modules: {
    menu,
    user,
    chat,
    todo,
    survey,
    restaurant,
    menus,
    room,
    pos,
    tag,
    statistique,
    reservation,
    helper,
    pack,
    manager,
    langue,
    article,
    currency,
    commande,
    order,
    client,
    espace,
    programmeF,
    VueHtml2pdf
  }
});
